import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the MaterialProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MaterialProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello MaterialProvider Provider');
  }

  getSourceList(real_type,page,pagesize){
    let params ={
      real_type:real_type,
      page:page,
      pagesize:pagesize,
      order_type: 'desc',
    };
    return this.http.hPost('/material/get_list',params);
  }

  // 请求amr 转码后的mp3链接
  getVoice(msg_id){
    let params = {
      msg_id:msg_id,
    };
    return this.http.hPost('/material/decoder',params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/material/material.ts